<template>
    <div class="view" :style="{paddingTop:barh(0)}">
        <div class="content">
            <my-top title="审批" lefttext="" :arrow="false"></my-top>
            <van-cell-group v-show="!next" title="基本信息">
              <van-cell title="所属分公司" :value="scoreData.branchCompany" />
              <van-cell title="所属项目" :value="scoreData.projectName" />
              <van-cell title="填报类型" :value="reportingTypeMap[scoreData.reportingType]" />
              <van-cell title="方案类型" :value="scoreData.programTypeName" />
              <van-cell title="方案名称" :value="scoreData.schemeName" />
              <van-cell title="现行版本" :value="scoreData.currentVersion" />
              <van-cell title="报审表编号" :value="scoreData.reviewCode" />
              <van-cell title="文件编码" :value="scoreData.fileCode" />
              <van-cell title="编制人员" :value="scoreData.compilerName" />
              <van-cell title="方案概况" :label="scoreData.programOverview" />
              <van-cell title="正文页数" :value="scoreData.bodyPages" />
              <van-cell title="附件页数" :value="scoreData.attachmentPages" />
              <van-cell title="是否为专业分包方案" :value="scoreData.whetherProfessionalSubcontracting == 'true' ? '是' : '否'" />
              <van-cell title="是否涉及重大费用诉求" :value="scoreData.whetherMajorExpense == 'true' ? '是' : '否'" />
              <van-cell title="附件"></van-cell>
              <div class="file-list" v-for="(item, index) in scoreData.fileInfoVOList" :key="item.id">
                <h5Download :fileInfo="item"></h5Download>
                <!-- <a class="file-item"
                    :href="downUrl(item.fileId)"
                    download
                >{{ item.fileName + item.suffixName }}</a> -->
              </div>
              <div class="btns">
                <van-button style="width: 100%;" @click="next = true" type="info">下一步</van-button>
              </div>
            </van-cell-group>

            <div v-show="next">
              <h1 class="card-title">{{ processName }}</h1>
              <van-cell title-class="cell-title" title="节点信息" :value="taskName" />
              <van-cell title-class="cell-title" title="审批人" :value="userInfo && userInfo.name ? userInfo.name : ''" />
              <van-cell title-class="cell-title" title="审批时间" :value="currentTime" />

              <!-- 施组方案审批 评分表单 start -->
              <scoreForm ref="scoreForm" :hideOpt="true" :businessId="businessId" :formData="scoreData"></scoreForm>
              <!-- 施组方案审批 评分表单 end -->

              <!-- 通用审批表单 start -->
              <baseForm ref="baseForm" :onValid="formValidate" :beforeSub="subScoreForm" :btnGroup="btns"></baseForm>
              <!-- 通用审批表单 end -->

              <!-- 审批流程信息start  -->
              <h1 class="card-title">审批流程信息</h1>
              <flowList :procInstId="procInstId"></flowList>
              <!-- 审批流程信息end  -->
            </div>
        </div>
    </div>
</template>

<script>
    import { Dialog, Button, Toast, CellGroup , Cell } from 'vant';
    import application from '@api/application';
    import baseForm from './baseForm.vue'
    import flowList from './flowList.vue'
    import scoreForm from './scoreForm.vue'
    import h5Download from '@/components/download/download.vue'
    export default {
        name:'shiGroupAudit',
        components: { baseForm, scoreForm, flowList, h5Download, Dialog, Button, Toast, CellGroup , Cell },
        data() {
            return {
              next: false,
              rules: [{ required: false }],
              btnLoading: {
                scoreBtn: false,
                approval: false,
                unUpproval: false
              },
              scoreData: {},
              btns: {
                other: '提交审批结果'
              },
              reportingTypeMap: {
                '0': '计划内填报',
                '1': '计划外填报'
              },
              opinions: '',
              businessId: '', // 指定业务ID
              procInstId: '', //当前流程实例ID
              taskId: '', //当前流程节点ID
              processName: '', //流程名称
              taskName: '', //当前流程节点名称
              taskDefKey: '', //任务标识
              currentTime: '', //当前审批时间
              currentUser: '', //当前审批人
              flowRequesting: false,
              detailUrl: null, //详情地址

              assignType: '', //节点类型   0 变量获取 1 处理人 2 候选人 3 候选组 4 会签
              assignCode: '', //候选组编码 岗位编码
              assignLevel: '', //层级 项目部 PD 分公司 BC 公司 CO
              businessType: '' //业务类型 0 项目
            }
        },
        created(){
          const { type, code, level, btype, businessId, procInstId, name, processName, detailUrl, taskId, taskDefKey, opinions } = this.$route.query
          if (type) {
              this.assignType = type
              this.assignCode = code
              this.assignLevel = level
              this.businessType = btype
          }
          if (opinions) {
            this.opinions = opinions
          }
          this.businessId = businessId
          if (!this.businessId) {
              Toast('无指定业务ID，将自动关闭');
              setTimeout(() => {
                  this.toback()
              }, 1500)
              return
          }
          this.procInstId = procInstId
          this.taskName = decodeURIComponent(name)
          this.processName = decodeURIComponent(processName)
          if (detailUrl) {
              this.detailUrl = decodeURIComponent(detailUrl)
          }
          // else {
          //     this.detailUrl = '/process/auditBusinessDetail'
          // }
          this.taskId = taskId
          this.taskDefKey = taskDefKey
          this.currentTime = this.formatTime(new Date(), true)

          this.getDetail()
        },
        computed: {
          active() {
            return this.$route.query.active
          },
          userInfo() {
            return localStorage.getItem("vuex") ? JSON.parse(localStorage.getItem("vuex")).user.userInfo : {}
          },
        },
        methods: {
            formValidate() {
              return new Promise((resolve, reject) => {
                let subForm = this.$refs.scoreForm.getFormData()
                let flag = (subForm.scoreTotal < 80 || subForm.vetoList.length > 0)
                this.$refs.scoreForm.formValidate().then((volid) => {
                  if (!volid) {
                    resolve(flag)
                  } else {
                    reject()
                  }
                }).catch((err) => {
                  reject()
                })
              })
            },
            subScoreForm() {
              let subForm = this.$refs.scoreForm.getFormData()
              let param = {
                ...subForm,
                id: this.businessId,
                opinion: this.$refs.baseForm.opinions
              }
              let flag = (subForm.scoreTotal < 80 || subForm.vetoList.length > 0)
              return new Promise((resolve, reject) => {
                application.submitTechnicalForm(param).then((res) => {
                  if (res && res.code == '200') {
                    resolve(flag)
                  } else {
                    reject()
                  }
                }).catch((err) => {
                  reject()
                })
              })
            },
            getDetail() {
              Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                loadingType: 'spinner',
              });
              application.technicalDetails({ id: this.businessId }).then((res) => {
                Toast.clear()
                if (res && res.code == '200') {
                  this.scoreData = res.data;
                  this.getemployeesList();
                }
              })
            },
            getemployeesList() {
              application.employeesList({ id: this.scoreData.projectId}).then((res) => {
                if (res && res.code == '200') {
                  let data = res.data;
                  data.forEach((item, index) => {
                    if (item.employeeId == this.scoreData.compiler) {
                      this.$set(this.scoreData, 'compilerName', item.employeeName)
                    }
                  })
                }
              })
            }
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    .view {
        .content {
          .card-title {
            font-size: 1.6rem;
            font-weight: normal;
            padding: 1rem 1.6rem;
            color: #999;
            background: #f7f8fa;
          }
          ::v-deep .cell-title {
            width: 8rem;
            flex: none;
          }
          .file-list {
            padding: 1rem 1.6rem;
            .file-item {
              word-break: break-all;
              color: #1989fa;
            }
          }
          .btns {
            overflow: hidden;
            padding: 1rem 1.6rem;
            ::v-deep .van-button {
              border-radius: 0.4rem;
              float: right;
              margin-left: 1rem;
            }
          }
        }
    }

</style>
